import { render, staticRenderFns } from "./commentSection.vue?vue&type=template&id=b10ab686"
import script from "./commentSection.vue?vue&type=script&lang=js"
export * from "./commentSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports